import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from 'components/utils/colors'

const StyledSectionGroup = styled.section`
  border-bottom: 1px solid ${colors.secondary70};
  && > * {
    border: none;
  }
`

const SidebarSectionGroup = ({ children }) => {
  return (
    <StyledSectionGroup data-test='sidebar-section-group'>
      {children}
    </StyledSectionGroup>
  )
}

SidebarSectionGroup.propTypes = {
  children: PropTypes.node,
}

export default SidebarSectionGroup
